import * as React from "react";
import { DS } from "../theme-default";

// Diacritics-insensitive term highlighting for search results, mirroring the
// backend's utf8_general_ci matching (masina == mașină).

// Folds per character so the result has exactly the same UTF-16 length as the
// input \u2014 highlight() maps folded match indices back onto the original string,
// which a plain NFD-normalize of the whole string would break for characters
// with multi-codepoint decompositions.
export function fold(value) {
  let out = "";
  for (const ch of value || "") {
    if (ch.length > 1) {
      out += ch; // astral pair \u2014 keep as-is, preserving UTF-16 length
      continue;
    }
    const folded = ch.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    out += folded.length === 1 ? folded.toLowerCase() : ch.toLowerCase();
  }
  return out;
}

export function splitTerms(query) {
  return fold(query)
    .split(/\s+/)
    .filter((term) => term.length > 0);
}

function matchIntervals(text, terms) {
  const foldedText = fold(text);
  const intervals = [];
  terms.forEach((term) => {
    let from = 0;
    let index = foldedText.indexOf(term, from);
    while (index !== -1) {
      intervals.push([index, index + term.length]);
      from = index + 1;
      index = foldedText.indexOf(term, from);
    }
  });
  intervals.sort((a, b) => a[0] - b[0]);

  const merged = [];
  intervals.forEach((interval) => {
    const last = merged[merged.length - 1];
    if (last && interval[0] <= last[1]) {
      last[1] = Math.max(last[1], interval[1]);
    } else {
      merged.push([interval[0], interval[1]]);
    }
  });
  return merged;
}

export function highlight(text, query) {
  if (!text) {
    return text;
  }
  const terms = splitTerms(query);
  if (terms.length === 0) {
    return text;
  }

  const intervals = matchIntervals(text, terms);
  if (intervals.length === 0) {
    return text;
  }

  const nodes = [];
  let cursor = 0;
  intervals.forEach(([start, end], i) => {
    if (start > cursor) {
      nodes.push(text.substring(cursor, start));
    }
    nodes.push(
      <mark
        key={i}
        style={{
          backgroundColor: DS.primaryTint,
          color: "inherit",
          padding: 0,
          borderRadius: 2,
        }}
      >
        {text.substring(start, end)}
      </mark>,
    );
    cursor = end;
  });
  if (cursor < text.length) {
    nodes.push(text.substring(cursor));
  }
  return nodes;
}
